import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import "../../userInfo/Users.css";
import LoadingGif from "src/components/layout/Loader";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { MembershipAndSubscriptionDetails } from "src/helper/interfaces";
import Cookies from "js-cookie";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import { formatCategory, formatDiffrentDate } from "src/utils/normalFuntions";

const getAllMembershipLeads = async (
   token: string,
   id: string
) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/membership-lead/${id}`, {
      headers: {
         "x-access-token": token,
      }

   })
};


const MembershipAndSalesDetailsPage = () => {

   const { id } = useParams();
   const [selectedLead, setSelectedLead] = useState<MembershipAndSubscriptionDetails>();

   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const Token = Cookies.get("token");




   useEffect(() => {
      if (Token) {
         dispatch(startLoading());
         getAllMembershipLeads(Token, id as string)
            .then((res) => {
               if (res?.data?.status_code === 200) {
                  const data = res?.data?.data;
                  // console.log(data)
                  setSelectedLead(data);
               }
               else {
                  Swal.fire({
                     icon: "error",
                     title: "Oops...",
                     text: `${res?.data?.msg}`,

                  });
               }
            })
            .catch((err: any) => {
               console.log(err);
            })
            .finally(() => {
               dispatch(stopLoading());
            });
      }
   }, [id]);

   const perchaseDate = formatDiffrentDate(selectedLead?.createdAt as string);
   let membershipValidity = null;
   if (selectedLead?.service_type === "subscription") {
      membershipValidity = formatDiffrentDate(selectedLead?.subscription_validity as string)
   }
   else {
      membershipValidity = formatDiffrentDate(selectedLead?.membership_validity as string)
   }


   return (
      <MainLayout
         showAllFilters={true}

      >

         <div className="mt-3 mb-3">

            <div className={` category-main me-2 p-md-4 `}  >
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>
                     : ""
               }

               <div className="row">
                  <div className="col-xxl-3 col-xl-4 p-2 theiaStickySidebar">
                     <div className="theiaStickySidebar"
                        style={{ paddingTop: " 0px", paddingBottom: "1px", position: "static", transform: 'none', top: "0px", left: "276px" }}>
                        <div className="card border-white ">
                           <div className="card-header border-1 " style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <div className="d-flex align-items-center flex-wrap row-gap-3">
                                 <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    <img
                                       src={
                                          selectedLead?.workerDetails?.profile_pic
                                             ? typeof selectedLead?.workerDetails.profile_pic === 'string'
                                                ? selectedLead?.workerDetails.profile_pic
                                                : URL.createObjectURL(selectedLead?.workerDetails.profile_pic)
                                             : undefined
                                       }
                                       alt=""
                                    />
                                 </div>
                                 <div className="d-flex flex-column">
                                    <h5 className="text-start mb-1">{selectedLead?.workerDetails?.name}</h5>
                                    <span className="text-start mb-1">{selectedLead?.workerDetails?.phone}</span>
                                    <span className="text-start mb-1">{formatCategory(selectedLead?.workerDetails?.worker_type as string)}</span>
                                 </div>
                              </div>
                           </div>
                           <div className="card-body text-start">
                              <h5 className="mb-3">Billing Details</h5>
                              <dl className="row mb-0">
                                 <dt className="col-md-5 fw-medium text-dark mb-3">Amount Paid :</dt>
                                 <dd className="col-md-7 mb-3">&#8377; {selectedLead?.payment_amount ?? 0}</dd>
                                 {
                                    selectedLead?.salesCommitionL1 ?
                                       <>
                                          <dt className="col-md-5 fw-medium text-dark mb-3">{`Sales Comm. L1 (${selectedLead?.salesL1CommPercent}%) `} :</dt>
                                          <dd className="col-md-7 mb-3">&#8377; {selectedLead?.salesCommitionL1 ?? 0}</dd></>
                                       : ""
                                 }
                                 {
                                    selectedLead?.salesCommitionL2 ?
                                       <>
                                          <dt className="col-md-5 fw-medium text-dark mb-3">{`Sales Comm. L2 (${selectedLead?.salesL2CommPercent}%) `} :</dt>
                                          <dd className="col-md-7 mb-3">&#8377; {selectedLead?.salesCommitionL2 ?? 0}</dd></>
                                       : ""
                                 }


                                 <dt className="col-md-5 fw-medium text-dark mb-3">Yows Comm. :</dt>
                                 <dd className="col-md-7 mb-3">&#8377; {selectedLead?.yowsComm ?? 0}
                                 </dd> <dt className="col-md-5 fw-medium text-dark mb-3">Yows Comm. Excl. GST :</dt>
                                 <dd className="col-md-7 mb-3">&#8377; {selectedLead?.amountExcludingGST ?? 0}</dd>
                                 <dt className="col-md-5 fw-medium text-dark mb-3">GST Amount :</dt>
                                 <dd className="col-md-7 mb-3">&#8377; {selectedLead?.gstOnYowsComm ?? 0}
                                 </dd>

                                 <dt className="col-md-5 fw-medium text-dark mb-3">GST Percentage :</dt>
                                 <dd className="col-md-7 mb-3">
                                    {selectedLead?.service_type === "subscription" ? selectedLead?.subscriptionDetails?.tax_percentage : selectedLead?.planDetails?.tax_percentage} %
                                 </dd>
                                 <dt className="col-md-5 fw-medium text-dark mb-3">Payment Id :</dt>
                                 <dd className="col-md-7 mb-3">{selectedLead?.payment_id}
                                 </dd>
                                 <dt className="col-md-5 fw-medium text-dark mb-3">Payment Order Id :</dt>
                                 <dd className="col-md-7 mb-3">{selectedLead?.payment_order_id}
                                 </dd>
                              </dl>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xxl-9 col-xl-8 p-2">
                     <div className="row ">
                        <div className="col-md-12">
                           <div className="card mb-0">
                              <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                 <h5 className="text-start mb-0" >
                                    {selectedLead?.service_type === "subscription" ? "Subscription" : "Membership"} Details
                                 </h5>
                              </div>
                              <div className="card-body">
                                 <div className="border rounded p-3 pb-0">
                                    <div className="row">
                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1"> Customer Type </p>
                                             <p className="text-start ">{selectedLead?.customer_type} </p>
                                          </div>
                                       </div>
                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Service Type </p>
                                             <p className="text-start ">{selectedLead?.service_type} </p>
                                          </div>
                                       </div>
                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Plan Id </p>
                                             <p className="text-start ">{selectedLead?.service_type === "subscription" ? selectedLead?.service_plan_id : selectedLead?.membership_plan_id} </p>
                                          </div>
                                       </div>
                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">WorkerId </p>
                                             <p className="text-start ">{selectedLead?.customer_id} </p>
                                          </div>
                                       </div>

                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Perchased At </p>
                                             <p className="text-start ">{`${perchaseDate?.formattedDate}, ${perchaseDate?.formattedHours}`} </p>
                                          </div>
                                       </div>


                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">{selectedLead?.service_type === "subscription" ? "Subscription" : "Membership"} Validity </p>
                                             <p className="text-start ">{`${membershipValidity?.formattedDate}, ${membershipValidity?.formattedHours}`}</p>
                                          </div>
                                       </div>


                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Referral Used  </p>
                                             <p className={`text-start font-weight-normal`}>{selectedLead?.is_referralCode_used ? "True" : "False"} </p>
                                          </div>
                                       </div>

                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Referral L1 </p>
                                             <p className="text-start "> {selectedLead?.used_referral_l1 ? selectedLead?.used_referral_l1 : "NA"} </p>
                                          </div>
                                       </div>
                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Referral L2  </p>
                                             <p className="text-start ">
                                                {selectedLead?.used_referral_l2 ? selectedLead?.used_referral_l2 : "NA"}
                                             </p>
                                          </div>
                                       </div>

                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Is Plan Active  </p>
                                             <p className="text-start ">
                                                {selectedLead?.is_active ? "True" : "False"}
                                             </p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>

                        </div>
                        {
                           selectedLead?.SalesProfessionalL1 ?
                              <div className="col-lg-6 p-2">
                                 <div className="card  mb-0">
                                    <div className="card-header d-flex justify-content-between text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="mb-0">
                                          Sales Details (L1)
                                       </h5>
                                       <div className='d-flex justify-content-end'>
                                          <Link to={`/workers/${selectedLead?.SalesProfessionalL1?._id}`}
                                             style={{ pointerEvents: "auto" }}>
                                             <button
                                                className={`py-2 px-3 text-dark font-weight-normal hover-effect`}>
                                                View Profile
                                             </button>
                                          </Link>

                                       </div>
                                    </div>
                                    <div className="card-body">
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          {/* <span className="text-dark text-start font-weight-bold  ">Image: </span> */}
                                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                             <img
                                                src={
                                                   selectedLead?.SalesProfessionalL1?.profile_pic
                                                      ? typeof selectedLead?.SalesProfessionalL1.profile_pic === 'string'
                                                         ? selectedLead?.SalesProfessionalL1.profile_pic
                                                         : URL.createObjectURL(selectedLead?.SalesProfessionalL1.profile_pic)
                                                      : undefined
                                                }
                                                alt=""
                                             />
                                          </div>

                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Sales ID: </span>
                                          <span className="text-start">{selectedLead?.SalesProfessionalL1?._id ?? "NA"} </span>
                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Name: </span>
                                          <span className="text-start">{selectedLead?.SalesProfessionalL1?.name ?? "NA"} </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Phone: </span>
                                          <span className="text-start">
                                             {selectedLead?.SalesProfessionalL1?.phone ?? "NA"} </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Sub Type: </span>
                                          <span className="text-start">
                                             {selectedLead?.SalesProfessionalL1?.sub_worker_type[0] ?? "NA"} </span>
                                       </div>
                                    </div>
                                 </div>
                              </div> : ''
                        }

                        {
                           selectedLead?.SalesProfessionalL2 ?
                              <div className="col-lg-6 p-2">
                                 <div className="card  mb-0">
                                    <div className="card-header d-flex justify-content-between text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="mb-0">
                                          Sales Details (L2)
                                       </h5>
                                       <div className='d-flex justify-content-end'>
                                          <Link to={`/workers/${selectedLead?.SalesProfessionalL2?._id}`}
                                             style={{ pointerEvents: "auto" }}>
                                             <button
                                                className={`py-2 px-3 text-dark font-weight-normal hover-effect`}>
                                                View Profile
                                             </button>
                                          </Link>
                                       </div>
                                    </div>
                                    <div className="card-body">
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          {/* <span className="text-dark text-start font-weight-bold  ">Image: </span> */}
                                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                             <img
                                                src={
                                                   selectedLead?.SalesProfessionalL2?.profile_pic
                                                      ? typeof selectedLead?.SalesProfessionalL2.profile_pic === 'string'
                                                         ? selectedLead?.SalesProfessionalL2.profile_pic
                                                         : URL.createObjectURL(selectedLead?.SalesProfessionalL2.profile_pic)
                                                      : undefined
                                                }
                                                alt=""
                                             />
                                          </div>

                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Sales ID: </span>
                                          <span className="text-start">{selectedLead?.SalesProfessionalL2?._id ?? "NA"} </span>
                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Name: </span>
                                          <span className="text-start">{selectedLead?.SalesProfessionalL2?.name ?? "NA"} </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Phone: </span>
                                          <span className="text-start">
                                             {selectedLead?.SalesProfessionalL2?.phone ?? "NA"} </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Sub Type: </span>
                                          <span className="text-start">
                                             {selectedLead?.SalesProfessionalL2?.sub_worker_type[0] ?? "NA"} </span>
                                       </div>
                                    </div>
                                 </div>
                              </div> : ""
                        }

                     </div>
                  </div>
               </div>
            </div>
         </div>
      </MainLayout>
   )

};



export default MembershipAndSalesDetailsPage;